import { ref } from 'vue'

// Shared counter — increment to request the modal open from anywhere in the app.
const _openCount = ref(0)

export function useClientModal() {
  function requestOpen() {
    _openCount.value++
  }

  return { _openCount, requestOpen }
}
